import React from "react";
import Slider from "react-slick";
import BackendClient from "../../BackendClient";
import Loading from "../../Components/Loading";

export default class SimpleSlider extends React.Component {
  state = {
    isFetched: false,
    isFetching: false,
    hasError: false
  };

  componentDidMount = () => {
    const { isFetching, isFetched, hasError } = this.state;
    if (!(isFetched && isFetching && hasError)) {
      this.setState({ isFetching: true });
      BackendClient.getCarousels({ expand: "items", "filter[key]": "banner" })
        .fetchJson()
        .then(res => {
          if (res) {
            const items = (res[0] || {}).items || [];
            return this.setState({
              isFetching: false,
              isFetched: true,
              items
            });
          }
          return this.setState({
            hasError: true,
            isFetched: true,
            errorMessage: "Fetch error"
          });
        });
    }
  };

  render() {
    let content;
    const { isFetched, isFetching, hasError, errorMessage, items } = this.state;
    if (isFetched) {
      if (hasError) {
        content = `ERROR=${errorMessage}`;
      } else {
        content = items.map((banner, index) => (
          <div
            className="office-banner"
            key={index}
            style={{ background: "url(" + banner.url + ")" }}
          >
            <div className="office-banner__content">
              <b
                className="office-banner__content-header"
                dangerouslySetInnerHTML={{ __html: banner.caption }}
              />
              <div className="office-banner__content-footer">
                <a
                  href={banner.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-about"
                >
                  <span className="text">Подробнее</span>
                  <img src="/images/icon-right-triangle.png" alt="" />
                </a>
              </div>
            </div>
          </div>
        ));
      }
    } else if (isFetching) {
      content = <Loading loading />;
    }

    return (
      <Slider
        dots
        infinite
        autoplay
        speed={500}
        slidesToShow={1}
        slidesToScroll={1}
        autoplaySpeed={20000}
      >
        {content}
      </Slider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/office/Slider.jsx